<template>
  <div>
    <div class="close-container">
      <el-button v-if="queryFlag && terminalAlertList.length > 0" class="verifone-btn" type="danger" plain icon="el-icon-close" @click="callStopAll">{{$t('message.closeAll')}}</el-button>
      <el-button v-else disabled class="verifone-btn" type="danger" plain icon="el-icon-close">{{$t('message.closeAll')}}</el-button>
    </div>

    <div>
      <el-table :data="terminalAlertList" border stripe height="400">
        <!-- 警告类型 -->
        <el-table-column :label="$t('message.type')" prop="type">
          <template slot-scope="scope">
            <div class="typeHref" @click="showAlertDetail(scope.row)">
              <span v-if="scope.row.type == 1">{{$t('message.appTaskFailure')}}</span>
              <span v-else-if="scope.row.type == 2">{{$t('message.terminalMove')}}</span>
              <span v-else-if="scope.row.type == 3">{{$t('message.tamper')}}</span>
              <span v-else-if="scope.row.type == 4">{{$t('message.lowMemory')}}</span>
              <span v-else-if="scope.row.type == 5">{{$t('message.printerAgeing')}}</span>
              <span v-else-if="scope.row.type == 6">{{$t('message.batteryAgeing')}}</span>
              <span v-else>{{$t('message.otherError')}}</span>
            </div>
          </template>
        </el-table-column>

        <!-- 时间 -->
        <el-table-column :label="$t('message.date')" prop="localReportTime" />

        <!-- 警告等级 -->
        <!-- 说明：level > 3 则警告级别为高级， level <= 3 警告级别为中级 -->
        <el-table-column :label="$t('message.level')" prop="level">
          <template slot-scope="scope">
            <div v-if="scope.row.level > 3">
              <span class="middle-icon"></span>
              <span>{{$t('message.middle')}}</span>
            </div>
            <div v-else>
              <span class="high-icon"></span>
              <span>{{$t('message.high')}}</span>
            </div>
          </template>
        </el-table-column>

        <!-- 关闭按钮 -->
        <el-table-column :label="$t('message.operation')" width="135">
          <template slot-scope="scope">
            <el-button v-if="queryFlag" class="verifone-btn" type="danger" plain icon="el-icon-close" @click="callStopTaskBefore(scope.row)">{{$t('message.close')}}</el-button>
            <el-button v-else disabled class="verifone-btn" type="danger" plain icon="el-icon-close">{{$t('message.close')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div>
      <el-pagination background layout="prev, pager, next" @current-change="queryTerminalAlert" :current-page="pageNum" :page-count="pages" />
    </div>

    <el-dialog title="" :visible.sync="alertDialogVisible" width="30%">
      <div class="dialog-body">
        <div v-show="type == 3">
          <div class="alert-item">
            <span>{{$t('message.tamperCode')}}:&nbsp;&nbsp;{{tamperCode}}</span>
          </div>
        </div>
        <div v-show="type == 1">
          <div class="alert-item">
            <span>{{$t('message.downloadTasks')}}:&nbsp;&nbsp;{{downloadTask}}</span>
          </div>
          <div class="alert-item">
            <span>{{$t('message.appName')}}:&nbsp;&nbsp;{{appName}}</span>
          </div>
          <div class="alert-item">
            <span>{{$t('message.failureCode')}}:&nbsp;&nbsp;{{failureCode}}</span>
          </div>
        </div>
        <div v-show="type == 2">
          <div class="alert-item">
            <span>{{$t('message.initialCoordinate')}}:&nbsp;&nbsp;{{targetCoordinate}}</span>
          </div>
          <div class="alert-item">
            <span>{{$t('message.currentCoordinate')}}:&nbsp;&nbsp;{{currentCoordinate}}</span>
          </div>
          <div class="alert-item">
            <span>{{$t('message.movingDistance')}}:&nbsp;&nbsp;{{movingDistance}}</span>
          </div>
        </div>
        <div v-show="type == 4">
          <div class="alert-item">
            <span>{{$t('message.freeMemory')}}:&nbsp;&nbsp;{{freeMemory}}M</span>
          </div>
          <div class="alert-item">
            <span>{{$t('message.freeStorage')}}:&nbsp;&nbsp;{{freeStorage}}M</span>
          </div>
        </div>
      </div>
    </el-dialog>

  </div>
</template>

<script>
    export default {
      name: "TerminalEditAlert",

      props: {
        terminalId:{
          required: true
        },
        queryFlag:{
          required: true
        }
      },

      data(){
        return{
          pageSize: 10,
          pageNum: 1,
          pages: 0,
          terminalAlertList:[],

          // ************************************** 警报明细 **************************************
          alertDialogVisible:false,
          type:'',
          downloadTask:'',
          appName:'',
          failureCode:'',
          tamperCode:'',
          freeMemory:'',
          freeStorage:'',
          targetCoordinate:'',
          currentCoordinate:'',
          movingDistance:''
        }
      },

      watch:{
        terminalId:function(){
          this.queryTerminalAlert(1);
        }
      },

      methods:{
        // 查询与终端相关的 警报信息
        queryTerminalAlert(pageNum){
          let _this = this,
            obj = {
              pageNum: pageNum,
              pageSize: this.pageSize,
              terminalId: this.terminalId
            };
          this.$axios({
            method: 'post',
            url: '/marketplace/alert/terminalEdit/page',
            data: obj,
            headers: {'Accept-Language': sessionStorage.getItem('acceptLanguage')}
          }).then(response => {
            if (response.data.code != "00") {
              _this.$message({
                type: "error",
                message: response.data.desc,
                duration: '3000',
              });
              return;
            } else {
              this.pages = response.data.data.pages;
              this.terminalAlertList = response.data.data.list;
            }
          }).catch((err) => {
            console.log(err);
          });
        },

        callStopTaskBefore(row){
          let _this = this;
          if (row.type == 2){
            this.$confirm(this.$i18n.t('message.moveAlertCloseInfo'), this.warn, {
              confirmButtonText: this.$i18n.t('message.yes'),
              cancelButtonText: this.$i18n.t('message.no'),
              type: 'warning'
            }).then(() => {
              _this.callStopTask(row.id, true);
            }).catch(() => {
              _this.callStopTask(row.id, false);
            })
          }else{
            _this.callStopTask(row.id,false);
          }
        },

        // 关闭警报
        callStopTask(id, closeMoveConf) {
          let that = this,
            obj = {
              "id": id,
              "closeMoveConf": closeMoveConf
            };
          this.$axios({
            method: 'post',
            url: '/marketplace/alert/close',
            headers: {'Accept-Language': sessionStorage.getItem('acceptLanguage')},
            data: obj
          }).then(response => {
            if (response.data.resultCode != 0) {
              that.$message({
                type: "error",
                message: response.data.desc,
                duration:'3000',
              });
              return;
            }else {
              that.$message({
                type: "success",
                message: this.$t('message.closeSuccess'),
                duration:'3000',
              });
              that.cancelDialogVisible = false;
              that.queryTerminalAlert(that.pageNum);
            }
          }).catch((err) => {
            console.log(err);
          });
        },

        // 关闭所有警报
        callStopAll() {
          let that = this,
            obj = {
              "terminalId": this.terminalId
            }

          this.$axios({
            method: 'post',
            url: '/marketplace/alert/close/terminalId',
            data: obj,
            headers: {'Accept-Language': sessionStorage.getItem('acceptLanguage')}
          }).then(response => {
            if (response.data.code != '00') {
              that.$message({
                type: "error",
                message: response.data.desc,
                duration:'3000',
              });
              return;
            }else {
              that.$message({
                type: "success",
                message: this.$t('message.closeSuccess'),
                duration:'3000',
              });
              that.cancelDialogVisible = false;
              that.queryTerminalAlert(that.pageNum);
            }
          }).catch((err) => {
            console.log(err);
          });
        },

        showAlertDetail(row) {
          let obj = {
            'alertId': row.id
          };
          this.$axios({
            method: 'post',
            url: "/marketplace/alert/detail",
            headers: {'Accept-Language': sessionStorage.getItem('acceptLanguage')},
            data: obj
          }).then(response => {
            if (response.data.resultCode != 0) {
              this.$message({
                type: "error",
                message: response.data.desc,
                duration:'3000',
              });
              return;
            }else {
              this.type = response.data.type;
              if(this.type == 1) {
                this.downloadTask = response.data.detail.taskName;
                this.appName = response.data.detail.appName;
                this.failureCode = response.data.detail.failureCode;
              }else if(this.type == 3) {
                this.tamperCode = response.data.detail.tamperCode;
              }else if(this.type == 4) {
                this.freeMemory = response.data.detail.memoryAvailable;
                this.freeStorage = response.data.detail.flashAvailable;
              }else if(this.type == 2) {
                this.targetCoordinate = response.data.detail.targetCoordinate;
                this.currentCoordinate = response.data.detail.coordinate;
                this.movingDistance = response.data.detail.distance;
              }
              this.alertDialogVisible = true;
            }
          }).catch((err) => {
            console.log(err);
          });
        },
      },

    }
</script>

<style scoped>
  .high-icon {
    display: inline-block;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    position: relative;
    top: 3px;
    background-color: #db1e08;
    border: 3px solid #f5c8c2;
  }
  .middle-icon {
    display: inline-block;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    position: relative;
    top: 3px;
    background-color: #fdb201;
    border: 3px solid #fdecbe;
  }

  .close-container {
    padding-right: 20px;
    margin-bottom: 10px;
    display: flex;
    display: -webkit-flex;
    justify-content: flex-end;
  }

  .typeHref {
    color: #3ba2ec;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/page/terminal/TerminalEditAlert.vue